import React from "react";

import { dynamicFilterFilter } from "app/filters/dynamicFilter";

import { ProgressBar } from "../../ProgressBar/ProgressBar";

export class SubcategoriesShare extends React.Component<any, any> {
    private dynamicFilter: any;

    constructor(props: FixmeType) {
        super(props);
        this.dynamicFilter = dynamicFilterFilter();
    }

    render() {
        const { value, row, format } = this.props;
        const width = row.ShareOfVisits ? row.ShareOfVisits * 100 : 0;
        return (
            <div className="swTable-progressBar">
                <ProgressBar width={width} />
                <span className="min-value">{this.dynamicFilter(value, format)}</span>
            </div>
        );
    }
}
